import React from 'react';
import { BaasicInput, BaasicSelect } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { translate } from 'core/utils';

const PalletizeFulfillmentOrderTemplate = ({
	store: {
		palletizingForm,
		warehouseOptions,
		palletOptions,
		selectedWarehouse,
		selectedPallet,
		onWarehouseChange,
		onPalletChange,
		debouncedPalletSearch,
		onKeyUp,
		setInputs,
		palletFindNotification,
		setRef,
		togglePallet,
		scanPackageNotification,
		undoNotification,
		onUndo,
		lastAction,
		onPrintLabel,
		label,
		isSeller,
		isSuperAdminOrganization,
		isWarehouse,
		isWarehouseDropdownLoading,
		isPalletDropdownLoading,
		setWarehouseRef,
		handleOnMenuScroll,
		onMenuClose,
		debouncedWarehouseSearch,
		openDeleteConfirmModal,
		deletable,
	},
	t,
}) => {
	return (
		<section>
			<form className="ReactModal__form" onSubmit={palletizingForm.onSubmit}>
				<div className="ReactModal__body">
					<div className="row">
						{(isSeller || isSuperAdminOrganization) && (
							<div className="col col-sml-12 col-med-6">
								<BaasicSelect
									autoFocus
									field={palletizingForm.$('warehouse.id')}
									options={warehouseOptions.slice()}
									value={selectedWarehouse}
									onChange={onWarehouseChange}
									isLoading={isWarehouseDropdownLoading}
									validation={false}
									reference={setWarehouseRef}
									onMenuScrollToBottom={handleOnMenuScroll}
									onInputChange={debouncedWarehouseSearch}
									onMenuClose={onMenuClose}
									isClearable={true}
									className="spc--bottom--sml flex--grow--1"
								/>
							</div>
						)}
						<div className="col col-sml-12 col-med-6">
							<div className="inputgroup spc--bottom--sml">
								<div className="inputgroup--main">
									<BaasicSelect
										field={palletizingForm.$('pallet.id')}
										isDisabled={(isSeller || isSuperAdminOrganization) && selectedWarehouse === null}
										clearable={false}
										value={selectedPallet}
										onChange={onPalletChange}
										isLoading={isPalletDropdownLoading}
										onInputChange={debouncedPalletSearch}
										options={palletOptions.slice()}
										validation={false}
										reference={setRef}
										onDelete={openDeleteConfirmModal}
										isSuperAdmin={isSuperAdminOrganization}
										hasDeletePermission={isSuperAdminOrganization || isWarehouse}
										canDelete={deletable}
									/>
								</div>
								<div className="inputgroup--aside align--v--bottom">
									<button
										className="btn btn--med btn--primary spc--left--sml"
										disabled={(isSeller || isSuperAdminOrganization) && !selectedWarehouse}
										onClick={togglePallet}
										type="button"
									>
										{t('FULFILLMENTORDER.PALLETIZINGMODE.NEWPALLET')}
									</button>
								</div>
							</div>
							{palletizingForm.error && !palletFindNotification && (
								<p className="padd--top--tny type--color--warning spc--bottom--sml">
									{translate(palletizingForm.error)}
								</p>
							)}
							{palletFindNotification && (
								<p
									className={
										palletFindNotification.includes('NOTFOUND')
											? 'type--color--warning spc--bottom--sml'
											: 'type--color--success spc--bottom--sml'
									}
								>
									{t(palletFindNotification)}
								</p>
							)}
						</div>
					</div>
					<div>
						<BaasicInput
							field={palletizingForm.$('trackingNumber')}
							onKeyUp={onKeyUp}
							disabled={!selectedPallet || !selectedWarehouse}
							reference={setInputs}
							className="spc--bottom--sml"
						/>
						{scanPackageNotification && (
							<p
								className={
									scanPackageNotification.includes('SUCCESS')
										? 'type--color--success spc--bottom--sml'
										: 'type--color--warning spc--bottom--sml'
								}
							>
								{t(scanPackageNotification)}
							</p>
						)}
						{undoNotification && <div className="type--color--success spc--bottom--sml">{t(undoNotification)}</div>}
					</div>
				</div>
				<div className="ReactModal__footer">
					<button
						className="btn btn--med btn--secondary spc--right--sml spc--bottom--sml"
						type="button"
						onClick={onUndo}
						disabled={!lastAction}
					>
						{t('UNDO')}
					</button>
					<button
						className="btn btn--med btn--secondary spc--bottom--sml"
						type="button"
						onClick={onPrintLabel}
						disabled={selectedPallet == null || selectedPallet.extra.label === ''}
					>
						<span className="fa fa-print spc--right--tny"></span>
						{t('PRINTLABEL')}
					</button>
				</div>
			</form>
			<iframe
				id="pdf-print-modal-pallet"
				name="pdf-print-modal-pallet"
				src={label}
				style={{ display: 'none' }}
			></iframe>
		</section>
	);
};

export default defaultTemplate(PalletizeFulfillmentOrderTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/PalletizeFulfillmentOrderTemplate.jsx